import { defineStore } from 'pinia';

export const useDashboardStore = defineStore('dashboard', {
  state: () => ({
    videoFeedUrl: 'http://127.0.0.1:5000/video',  // Flask video feed endpoint
    detections: [],                              // Live detection data
    classCounts: [],
    vehicleCounts: [],
  }),

  actions: {
    // Fetch recent detections
    async fetchDetections() {
      try {
        const res = await fetch('http://127.0.0.1:5000/real_time_detections');
        const data = await res.json();
        this.detections = data;
      } catch (error) {
        console.error('Error fetching detections:', error);
      }
    },

    // Fetch grouped class-wise counts
    async fetchClassCounts() {
      try {
        const res = await fetch('http://127.0.0.1:5000/real_time_class_distribution');
        const data = await res.json();
        this.classCounts = data;
      } catch (error) {
        console.error('Error fetching class counts:', error);
      }
    },

    // Fetch vehicle counts grouped by date
    async fetchVehicleCounts() {
      try {
        const res = await fetch('http://127.0.0.1:5000/real_time_vehicle_count');
        const data = await res.json();
        this.vehicleCounts = data;
      } catch (error) {
        console.error('Error fetching vehicle counts:', error);
      }
    }
  }
});
